export const anggaranPengeluaranFilter = (
  dropdownTahunAnggaranPengeluaran,
  dropdownUnitUsaha
) => {
  return [
    {
      id: "tahun",
      label: "Tahun",
      options: dropdownTahunAnggaranPengeluaran,
    },
    {
      id: "unit_usaha",
      label: "Unit Usaha",
      options: dropdownUnitUsaha,
    },
  ];
};
